import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cfg from 'cfg';
import RCore from 'RCore';
import Select from 'react-select';
import _ from 'lodash';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';

class TournamentPicker extends Component {
    state = {
        countryId: null,
        countries: [],
        tournament: {},
        tournaments: [],
        tournamentIds: '',
        tournamentId: this.props.tournamentId && +this.props.tournamentId,
        seasonId: +this.props.seasonId || null,
    };

    componentDidMount() {
        this.loadTournaments().then(t => {
            if (this.state.tournamentId) this.loadSeasonsForTournament();
        });
    }

    componentWillReceiveProps = nextProps => {
        //console.log('CWRP', nextProps.tournamentId, this.props.tournamentId, isNaN(nextProps.tournamentId));

        if (
            nextProps.tournamentId &&
            !isNaN(nextProps.tournamentId) &&
            nextProps.tournamentId != this.props.tournamentId
        ) {
            this.setState(
                {
                    seasonId: +nextProps.seasonId || null,
                    tournamentId: +nextProps.tournamentId,
                },
                () => {
                    if (this.state.tournamentId) this.loadTournaments();
                },
            );
        }

        // if (nextProps.resetPicker === true) {
        //     this.handleResetSelection();
        // }
    };

    loadTournaments() {
        const { sportId, pro, onChange } = this.props;
        let { tournamentId, countryId } = this.state;

        return fetch(`${cfg.apis.ss2}/tournaments?sportId=${sportId}`)
            .then(response => response.json())
            .then(tournaments => tournaments.filter(t => t.gender === 'male'))

            .then(tournaments => {
                if (pro) tournaments = _.filter(tournaments, t => RCore.proTournaments.indexOf(t.id) !== -1);

                var countries = _.chain(tournaments)
                    .map(t => _.pick(t, 'countryId', 'countryName'))
                    .uniqBy('countryId')
                    .value();

                if (tournamentId && !countryId) {
                    // restore countryId from tournamentId
                    var t = _.find(tournaments, t => {
                        return t.id === tournamentId;
                    });

                    if (t) countryId = t.countryId;
                    else {
                        countryId = null;
                        tournamentId = null;
                    }
                }
                this.setState({ tournaments, countries, countryId, tournamentId }, () => {
                    this.loadSeasonsForTournament();
                    onChange({ tournamentId });
                });
            })
            .catch(e => {
                console.error(e);
                this.setState({ tournaments: [], countries: [], countryId: null });
            });
    }

    loadSeasonsForTournament() {
        const { pro } = this.props;
        if (!this.state.tournamentId) return;

        return fetch(`${cfg.apis.ss2}/tournaments/${this.state.tournamentId}`)
            .then(response => response.json())
            .then(tournament => {
                if (pro)
                    tournament.seasons = _.filter(tournament.seasons, ts => RCore.proSeasons.indexOf(ts.id) !== -1);

                this.setState({ tournament });
            })
            .catch(e => {
                console.error(e);
                console.log('e');
                this.setState({ tournament: {} });
            });
    }

    handleCountryChange = (e, key, payload) => {
        this.props.onChange({ tournamentId: null, seasonId: null });
        //console.log('handleCountryChange ');
        this.setState({ countryId: payload, tournament: null, tournamentId: null, seasonId: null }, () => {
            //console.log('handleCountryChange ');
            this.loadSeasonsForTournament();
        });

        if (this.props.onCountryChange) {
            this.props.onCountryChange({ tournament: null, seasonId: null });
        }
    };

    handleTournamentChange = (e, key, payload) => {
        this.setState({ tournamentId: payload, seasonId: null }, () => {
            this.props.onChange({ tournamentId: payload, seasonId: null });
            this.loadSeasonsForTournament();
        });
    };

    handleMultiTournamentChange = payload => {
        const tournamentIds = payload.map(t => t.value);
        this.setState({ tournamentIds }, () => {
            this.props.onChange({ tournamentIds: tournamentIds });
        });
    };

    handleSeasonChange = (e, key, seasonId) => {
        const { tournamentId } = this.state;
        this.props.onChange({ tournamentId, seasonId });
        this.setState({ seasonId });
    };

    handleResetSelection = () => {
        this.setState({ countryId: null, tournament: null, tournamentId: null, seasonId: null }, () => {
            this.props.onChange({ tournamentId: null, seasonId: null });
        });
    };

    renderOption(option) {
        return <MenuItem key={option.value} value={option.value} primaryText={option.text} />;
    }

    render() {
        const { tournamentIds, tournamentId, seasonId, countryId, tournaments = [], countries = [] } = this.state;
        const { allowReset, multi, hideSeasonPicker, styleWrapper = {} } = this.props;
        const tournament = this.state.tournament || {};

        const tournamentsOptions = _.chain(tournaments)
            .filter(t => t.countryId === countryId)
            .orderBy(t => (t.isTop ? 0 : 10))
            .map(t => {
                if (multi) return { label: t.name, value: t.id };
                return { text: t.name, value: t.id };
            })
            .value();

        const countriesOptions = countries.map(c => ({ text: c.countryName, value: c.countryId }));
        const seasonOptions = _.chain(tournament.seasons || [])
            .orderBy(['year'], ['desc'])
            .map(c => ({ text: c.year, value: +c.id }))
            .value();
        const seasonPickerAvailable = tournamentId && seasonOptions.length > 0;
        // var currentSeasonYear = tournament && tournament.currentSeason && tournament.currentSeason.year;

        const currentSeason = seasonOptions && seasonOptions[0] && seasonOptions[0].value;

        return (
            <div style={styleWrapper}>
                <SelectField floatingLabelText="Country" value={countryId} onChange={this.handleCountryChange}>
                    {countriesOptions.map(this.renderOption)}
                </SelectField>
                {!multi && (
                    <SelectField
                        floatingLabelText="Tournament"
                        value={tournamentId}
                        disabled={!countryId}
                        onChange={this.handleTournamentChange}
                    >
                        {tournamentsOptions.map(this.renderOption)}
                    </SelectField>
                )}
                {multi && (
                    <div className="wdp-tournament-multi-picker">
                        <Select
                            value={tournamentIds}
                            multi
                            options={tournamentsOptions}
                            search
                            placeholder="Select leagues"
                            onChange={this.handleMultiTournamentChange}
                        />
                    </div>
                )}
                {!(hideSeasonPicker || multi) && (
                    <SelectField
                        floatingLabelText="Season"
                        value={seasonId || currentSeason}
                        disabled={!seasonPickerAvailable}
                        floatingLabelFixed={!!seasonPickerAvailable}
                        onChange={this.handleSeasonChange}
                    >
                        {/*{seasonPickerAvailable && <MenuItem key="current" value={null} primaryText="Current" />}*/}
                        {seasonOptions.map(this.renderOption)}
                    </SelectField>
                )}
                {allowReset && <FlatButton onClick={this.handleResetSelection} label="Reset tournament selection" />}
            </div>
        );
    }
}

TournamentPicker.defaultProps = {
    sportId: 1,
    pro: false,
    multi: false,
    allowReset: false,
    resetPicker: false,
    hideSeasonPicker: false,
    styleWrapper: {},
};

TournamentPicker.propTypes = {
    sportId: PropTypes.number,
    pro: PropTypes.bool,
    multi: PropTypes.bool,
    allowReset: PropTypes.bool,
    resetPicker: PropTypes.bool,
    hideSeasonPicker: PropTypes.bool,
    seasonId: PropTypes.number,
    tournamentId: PropTypes.number,
    styleWrapper: PropTypes.object,
    onCountryChange: PropTypes.func,
    onChange: PropTypes.func.isRequired,
};

export default TournamentPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/TournamentPicker.js
 **/